<script>
import { findJobCategoriesByJobTypeShortCodes, getJobCategoryLocaleKey } from '../../../libs/mapping/jobType'
import { getEmploymentTypeLocaleKey, sortEmploymentTypeNames } from '../../../libs/mapping/employmentType'
import { getPageMetadata } from '../../../libs/metadata/'

export default {
  computed: {
    /**
     * Description
     */
    metaDescription() {
      return this.$t('search.metaEmploymentOrJobTypeDescription', {
        employmentType: this.titleEmployment,
        jobType: this.titleJobCategory,
        numberOfJobs: this.paramTotal,
      })
    },
    /**
     * Keyword
     */
    metaKeyword() {
      return this.$t('search.metaKeyword')
    },
    /**
     * Title
     */
    metaTitle() {
      return this.$t('search.metaEmploymentOrJobTypeTitle', {
        employmentType: this.titleEmployment,
        jobType: this.titleJobCategory,
        numberOfJobs: this.paramTotal,
      })
    },

    titleEmployment() {
      const employmentTypes = this.filterQueryObject.employment
      if (Array.isArray(employmentTypes) && employmentTypes.length) {
        return sortEmploymentTypeNames(employmentTypes)
          .map((employment) => this.$t(getEmploymentTypeLocaleKey(employment)))
          .filter((l) => l)
          .join(this.$t('general.comma'))
      }
      return ''
    },

    titleJobCategory() {
      if (Array.isArray(this.filterQueryObject.jobType) && this.filterQueryObject.jobType.length > 0) {
        return findJobCategoriesByJobTypeShortCodes(this.filterQueryObject.jobType)
          .map(({ category }) => this.$t(getJobCategoryLocaleKey(category)))
          .filter((l) => l)
          .join(this.$t('general.comma'))
      }
      return ''
    },
  },
  head() {
    return getPageMetadata(this.metaTitle, this.metaDescription, null, this.metaKeyword)
  },
  props: {
    filterQueryObject: {
      default: () => ({}),
      type: Object,
    },
    /**
     * Total number of jobs matching search param
     */
    paramTotal: {
      default: 0,
      type: Number,
    },
  },
  // Handle to empty single root
  render(createElement) {
    return null
  },
}
</script>
